export default {
      id: "reefer__temperatura-usage",
      viewBox: "0 0 24 38",
      url: __webpack_public_path__ + "img/icons.svg#reefer__temperatura",
      toString: function () {
        return this.url;
      }
    }